import { render, staticRenderFns } from "./ServicePage.vue?vue&type=template&id=ebd3de44&scoped=true&"
import script from "./ServicePage.vue?vue&type=script&lang=ts&"
export * from "./ServicePage.vue?vue&type=script&lang=ts&"
import style0 from "./ServicePage.vue?vue&type=style&index=0&id=ebd3de44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd3de44",
  null
  
)

export default component.exports